<template>
  <b-form-select v-model="member.pipelineStatus" :options="statusOptions" @change="handleStatusChange"></b-form-select>
</template>
<script>
import { SetPipelineStatus } from '@/gql/members/Members.gql';

export default {
  props: {
    member: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      statusOptions: [{
          value: 'NEW',
          text: 'New'
        },
        {
          value: 'REACHED',
          text: 'Reached'
        },
        {
          value: 'SCHEDULED',
          text: 'Scheduled'
        }
      ]
    }
  },
  methods: {
    async handleStatusChange() {
      await this.$apollo.mutate({
        mutation: SetPipelineStatus,
        variables: {
          id: this.member.id,
          pipelineStatus: this.member.pipelineStatus,
        },
      });
      console.log('Updated');
    }
  },
}
</script>
